/* eslint-disable */

import printJS from 'print-js';
import { MarkerTable } from "./components/MarkerTable";

if (module.hot) {
  module.hot.accept();
}

const btnOpenPrintContext = document.getElementById("btn-print");
const btnSelectAll = document.getElementById("btn-selectall");
const printContext = document.getElementById("print-context");
const closePrintContext = document.getElementById("close-print-context");
const printAction = document.getElementById("btn-print-selection");

const markerTable = new MarkerTable();

window.onload = () => {
  document.getElementById('general-content').classList.remove('d-none')
  document.getElementById('page-cover').classList.add('d-none')
}

btnOpenPrintContext.onclick = () => {
  markerTable.switchCheckableVisible();
  btnOpenPrintContext.classList.add("d-none");
  printContext.classList.remove("d-none");
};

btnSelectAll.onclick = () => {
  markerTable.switchSelectAll();
};

closePrintContext.onclick = () => {
  markerTable.switchCheckableVisible();
  btnOpenPrintContext.classList.remove("d-none");
  printContext.classList.add("d-none");
};

printAction.onclick = () => {
  const imgsURLs = markerTable.selectedImagesURLS();

  if (imgsURLs.length === 0) {
    return;
  }

  printJS({
    printable: imgsURLs,
    type: 'image',
    showModal: true,
    imageStyle: 'max-width: 400px'
  });
}
